import React, { useState, useContext, useEffect } from "react";
import Input from "../components/Input";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../context/userContext";
import LoadingAnimation from "../components/Loader";

const Login = () => {
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const token = currentUser?.token;

  const [error, setError] = useState("");
  const [focused, setFocused] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
    setLoading(false);
  }, []);

  if (loading || submitLoading) {
    return <LoadingAnimation />;
  }

  const handleFocus = () => setFocused(true);

  const handleBlur = () => {
    if (userData === "") {
      setFocused(false);
    }
  };

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const loginUser = async (event) => {
    event.preventDefault();
    setSubmitLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/login`,
        userData
      );

      const user = response.data;
      setCurrentUser(user);
      navigate("/");
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Invalid email or password.");
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred.");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="register-form login form">
      <h2>Login</h2>

      {error && (
        <h6 className="error">
          <FontAwesomeIcon icon={faCircleExclamation} /> {error}
        </h6>
      )}

      <form onSubmit={loginUser}>
        <Input
          label="Email"
          placeholder=""
          name="email"
          value={userData.email}
          onChange={handleChange}
          handleFocus={handleFocus}
          handleBlur={handleBlur}
          focused={focused}
          type="email"
        />

        <Input
          label="Password"
          type="password"
          name="password"
          placeholder=""
          value={userData.password}
          onChange={handleChange}
          handleFocus={handleFocus}
          handleBlur={handleBlur}
          focused={focused}
        />

        <button className="btn" type="submit">
          Login
        </button>
      </form>

      <small className="small">
        Don't have an account?
        <Link to="/register" style={{ color: "#999" }}>
          Register
        </Link>
      </small>
    </div>
  );
};

export default Login;
